export const statesplit = {
       showModal: false,
        polygon: null,
        color: null,
        fillColor: null,
        page: "NEW_TASK",
        fab: "",
        fab_open: true,
        zones: [],
        showErrorModal: false,
        errorMessage: "",
        drawButton: false,
        tracktorModel: false,
        tracktorName: null,
        tracktorColor: null,
        implementModel: false,
        implementName: null,
        implementSrc: null,
        mapview: 0,
        zoom: 17,
        showContent: true,
        dmsString: "",
        eye: "100 m",
        edit: null,
        isHover: false,
        isRabitHover: false,
        fabHover: false,
        mapViewHover: false,
        work_view:false,
        speed:1.4,
        flexImpName:"Rotary Tiller",
        flexCroplandName:"",
        flexMars:"",
        height:null,
        fullscreen:false,
}